import { logger } from '@damofire/data-commons';
import { Remote, wrap } from 'comlink';
import { Observer, Subject } from 'rxjs';
import { WarehouseSyncStepContextEvent, WarehouseSyncStepTask, WarehouseSyncStepTaskContext } from '../executors';
import { WarehouseConfigsStepsWorker } from '../workers/configs.steps.worker';
import { executeWorker, WarehouseSyncStepWorkerFactory } from './steps-utils';

class WarehouseConfigsSyncWorkerFactory implements WarehouseSyncStepWorkerFactory<WarehouseConfigsStepsWorker> {
  async createWorker(environment: any): Promise<[Worker, WarehouseConfigsStepsWorker | Remote<WarehouseConfigsStepsWorker>]> {
    if (environment.appConfig.watson.useWebworkers) {
      const warehouseWorker = new Worker(new URL('../workers/configs.steps.worker', import.meta.url), { type: 'module' });
      const warehouseWorkerProxy = wrap<typeof WarehouseConfigsStepsWorker>(warehouseWorker);
      const workerService = await new warehouseWorkerProxy();
      return [warehouseWorker, workerService];
    }

    return [null, new WarehouseConfigsStepsWorker()];
  }
}

export class WarehouseDownloadConfigsSyncStepTask implements WarehouseSyncStepTask {
  constructor(private readonly environment: any) {}

  name(): string {
    return `DOWN_CFG_TASK`;
  }

  async execute(ctx: WarehouseSyncStepTaskContext, listener: Observer<WarehouseSyncStepContextEvent>, taskBreaker: Subject<boolean>): Promise<void> {
    logger.debug('Executing download configs sync task.');
    await executeWorker(ctx, this.environment, listener, new WarehouseConfigsSyncWorkerFactory(), taskBreaker);
  }
}
